import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Source } from 'entities/Analytics/model/Source'

export class RowSource extends RowBase<Source> {
  constructor(origin: Source) {
    super(origin)

    makeObservableRowBase(this)
    this.setDisabled(Boolean(origin.is_deleted))
  }

  get name() {
    return this.origin.name
  }

  get type() {
    return this.origin.type
  }

  get status() {
    return this.origin.status
  }

  get messages() {
    return this.origin.messages
  }

  get credits() {
    return this.origin.credits
  }
}
